import { AntdWrapper } from 'appClients/shared/AntdWrapper';
import styles from './styles.module.css';
import errorImage from './error-image.png';
import React from 'react';
import * as translations from './strings';
import { getLangKey } from 'appJS/models/Language';
import { Button } from 'antd';

const strings = translations[getLangKey()];

export const DesignFeedbackError = () => {
  return (
    <AntdWrapper>
      <div className={styles.errorContainer}>
        <div className={styles.errorWrapper}>
          <div className={styles.errorContent}>
            <img
              src={errorImage}
              className={styles.sharingExtensionImage}
              alt="sharing_extension_image"
            />
            <h2 className={styles.header}>{strings.invited}</h2>
            <p>{strings.contactOwnerGeneric}</p>
            <Button
              type={'primary'}
              onClick={() => (window.location.href = '/organizations')}
              style={{ width: '80%' }}
            >
              Go back to My Projects
            </Button>
          </div>
        </div>
      </div>
    </AntdWrapper>
  );
};
